type RequestMoreTooltipProps = {
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
};

export function RequestMoreTooltip({ isOpen, onToggle, onClose }: RequestMoreTooltipProps) {
  return (
    <div className="relative flex items-center">
      <button
        type="button"
        className="border-none bg-transparent p-0 text-xs text-gray-500 underline decoration-solid decoration-auto"
        data-testid="request-more-trigger"
        onClick={onToggle}
      >
        Request more
      </button>
      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={onClose} />
          <div className="absolute right-0 top-full z-50 mt-2 w-64 max-w-[calc(100vw-2rem)] rounded-md bg-blue-700 px-3 py-2 text-xs text-white shadow-lg">
            <div className="absolute -top-1 right-6 h-2 w-2 rotate-45 bg-blue-700" />
            <p>
              We&apos;ll get back to you soon — demand
              <br />
              is currently high.
            </p>
          </div>
        </>
      )}
    </div>
  );
}
